// Phase 81vv — PickLeague homepage VĐV (mock data)
// Mock data shape khớp blueprint trong /app/design_guidelines.json.

export const mockStats = {
  points: 2676,
  rank: 128,
  winrate: 50,
  tournaments: 12,
};

export const mockHeroTournaments = [
  {
    id: "t1",
    subtitle: "Pickleball Superstars Cup",
    title: "TÂY NGUYÊN OPEN 2026",
    date: "09 - 10.05.2026",
    location: "Đắk Lắk",
    daysLeft: 12,
  },
  {
    id: "t2",
    subtitle: "Pickleball Pro Series",
    title: "SÀI GÒN MASTERS 2026",
    date: "20 - 22.06.2026",
    location: "TP. Hồ Chí Minh",
    daysLeft: 24,
  },
  {
    id: "t3",
    subtitle: "Pickleball Champions Series",
    title: "HÀ NỘI ELITE CUP",
    date: "12 - 14.07.2026",
    location: "Hà Nội",
    daysLeft: 38,
  },
];

export const mockLiveMatches = [
  {
    id: "m1",
    eventName: "Đôi Nam 5.5",
    round: "Bán kết",
    court: 5,
    teamA: [
      { name: "Kiệt Touch Cinema", avatar: "/avatar-fallback.svg" },
      { name: "Nhơn Mỹ Thiện", avatar: "/avatar-fallback.svg" },
    ],
    teamB: [
      { name: "Bóng Long Xuyên", avatar: "/avatar-fallback.svg" },
      { name: "Cao Thanh Dũng", avatar: "/avatar-fallback.svg" },
    ],
    scoreA: 11,
    scoreB: 7,
    game: 1,
    gameScore: "1 - 0",
    viewers: 312,
  },
];

export const mockUpcoming = [
  {
    id: "u1",
    title: "JOY CUP LẦN 2 - 2026",
    date: "23 - 24.05.2026",
    location: "TP. Hồ Chí Minh",
    currentReg: 128,
    maxReg: 160,
    status: "closing",
    shortLogo: "JOY",
  },
  {
    id: "u2",
    title: "TRITON CUP 2026",
    date: "06 - 07.06.2026",
    location: "Hà Nội",
    currentReg: 64,
    maxReg: 128,
    status: "open",
    shortLogo: "TRT",
  },
  {
    id: "u3",
    title: "ĐÀ NẴNG OPEN 2026",
    date: "14 - 15.06.2026",
    location: "Đà Nẵng",
    currentReg: 90,
    maxReg: 192,
    status: "open",
    shortLogo: "DNG",
  },
];

export const mockStreams = [
  {
    id: "s1",
    title: "Sân trung tâm – Court 1",
    viewers: 312,
    thumbnail:
      "https://images.unsplash.com/photo-1761644518970-2ed0ab543e1b?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    id: "s2",
    title: "Sân 2 – Court 2",
    viewers: 184,
    thumbnail:
      "https://images.unsplash.com/photo-1737229471661-78a6a16f33bf?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
];

export const mockRanking = [
  { id: "r1", rank: 1, name: "Kiệt Touch Cinema", score: 2743, trend: "up", avatar: "/avatar-fallback.svg" },
  { id: "r2", rank: 2, name: "Bóng Long Xuyên", score: 2688, trend: "up", avatar: "/avatar-fallback.svg" },
  { id: "r3", rank: 3, name: "Nguyễn Thái Huy", score: 2552, trend: "down", avatar: "/avatar-fallback.svg" },
  { id: "r4", rank: 4, name: "Phạm Thanh Phong", score: 2431, trend: "up", avatar: "/avatar-fallback.svg" },
  { id: "r5", rank: 5, name: "Phan Anh Tú", score: 2310, trend: "up", avatar: "/avatar-fallback.svg" },
];

export const mockHighlights = [
  { id: "h1", title: "Rally đẹp nhất tuần", duration: "01:24", views: "2.1K", thumbnail: "https://images.unsplash.com/photo-1761644518970-2ed0ab543e1b?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { id: "h2", title: "Smash cực cháy", duration: "00:58", views: "1.6K", thumbnail: "https://images.unsplash.com/photo-1737229471661-78a6a16f33bf?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { id: "h3", title: "Pha cứu bóng không tưởng", duration: "01:10", views: "980", thumbnail: "https://images.pexels.com/photos/10340634/pexels-photo-10340634.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: "h4", title: "Volley đỉnh cao", duration: "00:42", views: "1.2K", thumbnail: "https://images.unsplash.com/photo-1761644518970-2ed0ab543e1b?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
];
